
$(document).ready(function () {
  $("#term-csr h2:contains('地域貢献CSR')").each(function () {
    var mojiretsu = $(this).html();
    $(this).html(mojiretsu.replace("地域貢献CSR", '地域貢献<br />CSR'));
  });
});
